<script lang="ts">
  import { LIVESTREAM_STATUS } from '../../../const/livestream'
  import videoStore from '../../../stores/video.svelte'
  import LiveStatusWaitingScreen from './LiveStatusWaitingScreen.svelte'
  import LiveStatusEndingScreen from './LiveStatusEndingScreen.svelte'
  import Overlay from '../Overlay.svelte'
  import LiveBottomPanel from './LiveBottomPanel.svelte'
</script>

{#if videoStore.state.liveStatus === LIVESTREAM_STATUS.WAITING}
  <LiveStatusWaitingScreen />
{:else if videoStore.state.liveStatus === LIVESTREAM_STATUS.ENDED}
  <LiveStatusEndingScreen />
{:else}
  <Overlay>
    <LiveBottomPanel />
  </Overlay>
{/if}
